module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-card-snow-7036ca8c58e0a293a1cb0b70b4d7a5cf.webp";